var AppRoutes = /** @class */ (function () {
    function AppRoutes() {
    }
    // Lets keep a convention of setting up the key as a path
    // without a slash "/" excluding the base
    AppRoutes.base = {
        path: '/',
        key: 'base',
    };
    AppRoutes.notFound = {
        path: '/404',
        key: '404',
    };
    AppRoutes.notAuth = {
        path: '/auth',
        key: 'auth',
    };
    AppRoutes.login = {
        path: '/login',
        key: 'login',
    };
    AppRoutes.dashboard = {
        path: '/dashboard',
        key: 'dashboard',
    };
    AppRoutes.templates = {
        path: '/templates',
        key: 'templates',
    };
    AppRoutes.template = {
        path: '/template',
        key: 'template',
    };
    AppRoutes.editTemplate = {
        path: '/template/:id',
        key: 'edittemplates',
    };
    AppRoutes.searches = {
        path: '/searches',
        key: 'searches',
    };
    // SEO Text in HomePage
    AppRoutes.seoText = {
        path: '/seo-text',
        key: 'seo-text',
    };
    AppRoutes.search = {
        path: '/search',
        key: 'search',
    };
    AppRoutes.editSearch = {
        path: '/search/:id',
        key: 'editSearchs',
    };
    // Products
    AppRoutes.products = {
        path: '/products',
        key: 'products',
    };
    AppRoutes.product = {
        path: '/product',
        key: 'product',
    };
    AppRoutes.editProduct = {
        path: '/product/:id',
        key: 'editProducts',
    };
    // Product variants
    AppRoutes.variants = {
        path: '/variants',
        key: 'variants',
    };
    AppRoutes.variant = {
        path: '/variant',
        key: 'variant',
    };
    AppRoutes.editVariant = {
        path: '/variant/:variantId',
        key: 'editVariant',
    };
    // Product reviews
    AppRoutes.reviews = {
        path: '/reviews',
        key: 'reviews',
    };
    AppRoutes.review = {
        path: '/review',
        key: 'review',
    };
    AppRoutes.editReview = {
        path: '/review/:reviewId',
        key: 'editReview',
    };
    // Color images
    AppRoutes.colorImage = {
        path: '/colorImage',
        key: 'colorImage',
    };
    // Additional Image
    AppRoutes.additionalImage = {
        path: '/additionalImage',
        key: 'additionalImage',
    };
    // file upload
    AppRoutes.fileUpload = {
        path: '/fileUpload',
        key: 'fileUpload',
    };
    // volume promotions
    AppRoutes.volumePromotions = {
        path: '/volumePromotions',
        key: 'volumePromotions',
    };
    AppRoutes.volumePromotion = {
        path: '/volumePromotion',
        key: 'volumePromotion',
    };
    AppRoutes.editVolumePromotion = {
        path: '/volumePromotion/:id',
        key: 'volumePromotion',
    };
    AppRoutes.volumePromotionsImport = {
        path: '/volumePromotions/import',
        key: 'volumePromotionsImport',
    };
    AppRoutes.volumePromotionLevel = {
        path: '/level',
        key: 'volumePromotionsLevel',
    };
    AppRoutes.editVolumePromotionLevel = {
        path: '/level/:levelId',
        key: 'editVolumePromotionsLevel',
    };
    AppRoutes.volumePromotionsLevels = {
        path: '/levels',
        key: 'volumePromotionsLevels',
    };
    // variant images
    AppRoutes.variantImages = {
        path: '/variantImages',
        key: 'variantImages',
    };
    AppRoutes.variantImage = {
        path: '/variantImage',
        key: 'variantImage',
    };
    AppRoutes.editVariantImage = {
        path: '/variantImage/:variantImageId',
        key: 'editVariantImage',
    };
    // Product filters
    AppRoutes.filterOptions = {
        path: '/filterOptions',
        key: 'filterOptions',
    };
    AppRoutes.filterOption = {
        path: '/filterOption',
        key: 'filterOption',
    };
    AppRoutes.editFilterOption = {
        path: '/filterOption/:optionId',
        key: 'editFilterOption',
    };
    // delivery methods
    AppRoutes.deliveryMethods = {
        path: '/deliveryMethods',
        key: 'deliveryMethods',
    };
    AppRoutes.deliveryMethod = {
        path: '/deliveryMethod',
        key: 'deliveryMethod',
    };
    AppRoutes.freeShipping = {
        path: '/freeShipping',
        key: 'freeShipping',
    };
    AppRoutes.editDeliveryMethod = {
        path: '/deliveryMethod/:id',
        key: 'editDeliveryMethod',
    };
    // promo code
    AppRoutes.promoCodes = {
        path: '/promoCodes',
        key: 'promoCodes',
    };
    AppRoutes.promoCode = {
        path: '/promoCode',
        key: 'promoCode',
    };
    AppRoutes.editPromoCode = {
        path: '/promoCode/:id',
        key: 'editPromoCode',
    };
    // Special Offers
    AppRoutes.specialOffers = {
        path: '/specialOffers',
        key: 'specialOffers',
    };
    AppRoutes.specialOffer = {
        path: '/specialOffer',
        key: 'specialOffer',
    };
    AppRoutes.editSpecialOffer = {
        path: '/specialOffer/:id',
        key: 'editSpecialOffer',
    };
    // RelatedCollections
    AppRoutes.relatedCollections = {
        path: '/relatedCollections',
        key: 'relatedCollections',
    };
    AppRoutes.relatedCollection = {
        path: '/relatedCollection',
        key: 'relatedCollection',
    };
    // Suggestion Offers
    AppRoutes.suggestionOffers = {
        path: '/suggestionOffers',
        key: 'suggestionOffers',
    };
    AppRoutes.suggestionOffer = {
        path: '/suggestionOffer',
        key: 'suggestionOffer',
    };
    AppRoutes.editSuggestionOffer = {
        path: '/suggestionOffer/:id',
        key: 'editSuggestionOffer',
    };
    // Suggestion Offers
    AppRoutes.adjustmentLevels = {
        path: '/adjustmentLevels',
        key: 'adjustmentLevels',
    };
    AppRoutes.adjustmentLevel = {
        path: '/adjustmentLevel',
        key: 'adjustmentLevel',
    };
    // payment methods
    AppRoutes.paymentMethods = {
        path: '/paymentMethods',
        key: 'paymentMethods',
    };
    AppRoutes.paymentMethod = {
        path: '/paymentMethod',
        key: 'paymentMethod',
    };
    AppRoutes.editPaymentMethod = {
        path: '/paymentMethod/:id',
        key: 'editPaymentMethod',
    };
    // Brands
    AppRoutes.brands = {
        path: '/brands',
        key: 'brands',
    };
    AppRoutes.brand = {
        path: '/brand',
        key: 'brand',
    };
    AppRoutes.editBrand = {
        path: '/brand/:brandId',
        key: 'editBrand',
    };
    // Brands
    AppRoutes.staticImages = {
        path: '/staticImages',
        key: 'staticImages',
    };
    AppRoutes.staticImage = {
        path: '/staticImage',
        key: 'staticImage',
    };
    // Samples
    AppRoutes.samples = {
        path: '/samples',
        key: 'samples',
    };
    // Refreshs
    AppRoutes.refreshs = {
        path: '/refreshs',
        key: 'refreshs',
    };
    AppRoutes.gifts = {
        path: '/gifts',
        key: 'gifts',
    };
    AppRoutes.gift = {
        path: '/gift',
        key: 'gift',
    };
    AppRoutes.sample = {
        path: '/sample',
        key: 'sample',
    };
    AppRoutes.editSample = {
        path: '/sample/:sampleId',
        key: 'editSample',
    };
    AppRoutes.editGift = {
        path: '/gift/:giftId',
        key: 'editGift',
    };
    // ProductLines
    AppRoutes.productLines = {
        path: '/productLines',
        key: 'productLines',
    };
    AppRoutes.productLine = {
        path: '/productLine',
        key: 'productLine',
    };
    AppRoutes.editProductLine = {
        path: '/productLine/:productLineId',
        key: 'editProductLine',
    };
    // Static Page Slides
    AppRoutes.staticPageSlides = {
        path: '/slides',
        key: 'staticPageSlides',
    };
    // Static page Slide create
    AppRoutes.staticPageSlide = {
        path: '/slide',
        key: 'staticPageSlide',
    };
    // Static page Slide Edit
    AppRoutes.editStaticPageSlide = {
        path: '/slide/:staticPageSlideId',
        key: 'editStaticPageSlide',
    };
    // ProductLines
    AppRoutes.rituals = {
        path: '/rituals',
        key: 'rituals',
    };
    AppRoutes.ritual = {
        path: '/ritual',
        key: 'ritual',
    };
    AppRoutes.editRitual = {
        path: '/ritual/:ritualId',
        key: 'editRitual',
    };
    // Brands
    AppRoutes.staticPages = {
        path: '/staticPages',
        key: 'staticPages',
    };
    AppRoutes.brandCategories = {
        path: '/brandCategories',
        key: 'brandCategories',
    };
    AppRoutes.staticPage = {
        path: '/staticPage',
        key: 'staticPage',
    };
    AppRoutes.editStaticPage = {
        path: '/staticPage/:staticPageId',
        key: 'editStaticPages',
    };
    AppRoutes.editNormalStaticPage = {
        path: '/staticPage/:staticPageId',
        key: 'editNormalStaticPages',
    };
    // Static pages + product lines
    AppRoutes.listStaticPageProductLines = {
        path: '/staticPage/:staticPageId' + AppRoutes.productLines.path,
        key: 'listStaticPageProductLines',
    };
    // Brand slides
    AppRoutes.brandSlides = {
        path: '/brandSlides',
        key: 'brandSlides',
    };
    AppRoutes.brandSlide = {
        path: '/brandSlide',
        key: 'brandSlide',
    };
    AppRoutes.editBrandSlide = {
        path: '/brandSlide/:brandSlideId',
        key: 'editBrandSlide',
    };
    // Static Page Brands Slides
    AppRoutes.staticPageBrandSlides = {
        path: '/staticPageSlides',
        key: 'staticPageSlides',
    };
    AppRoutes.staticPageBrandSlide = {
        path: '/staticPageSlide',
        key: 'staticPageSlide',
    };
    AppRoutes.editStaticPageBrandSlide = {
        path: '/staticPageSlide/:staticPageSlideId',
        key: 'editStaticPageSlide',
    };
    // OptionValues
    AppRoutes.optionValues = {
        path: '/optionValues',
        key: 'optionValues',
    };
    AppRoutes.optionValue = {
        path: '/optionValue',
        key: 'optionValue',
    };
    AppRoutes.editOptionValue = {
        path: '/optionValue/:valueId',
        key: 'editOptionValue',
    };
    // OptionTypes
    AppRoutes.optionTypes = {
        path: '/optionTypes',
        key: 'optionTypes',
    };
    AppRoutes.optionType = {
        path: '/optionType',
        key: 'optionType',
    };
    AppRoutes.editOptionType = {
        path: '/optionType/:id',
        key: 'editOptionType',
    };
    // Regions
    AppRoutes.regions = {
        path: '/regions',
        key: 'regions',
    };
    AppRoutes.region = {
        path: '/region',
        key: 'region',
    };
    AppRoutes.editRegion = {
        path: '/region/:id',
        key: 'editRegion',
    };
    // Prices
    AppRoutes.prices = {
        path: '/prices',
        key: 'prices',
    };
    AppRoutes.price = {
        path: '/price',
        key: 'price',
    };
    AppRoutes.editPrice = {
        path: '/price/:id',
        key: 'editPrice',
    };
    // Users
    AppRoutes.users = {
        path: '/users',
        key: 'users',
    };
    // Orders
    AppRoutes.orders = {
        path: '/orders',
        key: 'orders',
    };
    AppRoutes.problemOrders = {
        path: '/problemOrders',
        key: 'problemOrders',
    };
    AppRoutes.order = {
        path: '/order/:num',
        key: 'order',
    };
    // Categories
    AppRoutes.categories = {
        path: '/categories',
        key: 'categories',
    };
    AppRoutes.category = {
        path: '/category',
        key: 'category',
    };
    AppRoutes.brandCategory = {
        path: '/brandCategory',
        key: 'brandCategory',
    };
    AppRoutes.editCategory = {
        path: '/category/:categoryId',
        key: 'editCategory',
    };
    AppRoutes.categorySlides = {
        path: "/categorySlides",
        key: "categorySlides",
    };
    AppRoutes.categorySlide = {
        path: '/categorySlide',
        key: 'categorySlide',
    };
    AppRoutes.editCategorySlide = {
        path: '/categorySlide/:categorySlideId',
        key: 'editCategorySlide',
    };
    AppRoutes.categoryProducts = {
        path: '/category/:id/products',
        key: 'categoryProducts',
    };
    AppRoutes.editBrandCategory = {
        path: '/brandCategory/:id',
        key: 'editBrandCategory',
    };
    // Slides
    AppRoutes.slides = {
        path: '/slides',
        key: 'slides',
    };
    AppRoutes.slide = {
        path: '/slide',
        key: 'slide',
    };
    AppRoutes.editSlide = {
        path: '/slide/:id',
        key: 'editSlide',
    };
    // Promo Slides
    AppRoutes.promoSlides = {
        path: '/promoSlides',
        key: 'promoSlides',
    };
    AppRoutes.promoSlide = {
        path: '/promoSlide',
        key: 'promoSlide',
    };
    AppRoutes.editPromoSlide = {
        path: '/editPromoSLide/:id',
        key: 'editPromoSLide',
    };
    AppRoutes.signOut = {
        path: '/sign-out',
        key: 'sign-out',
    };
    // Product aromatic notes
    AppRoutes.aromaticNotes = {
        path: '/aromaticNotes',
        key: 'aromaticNotes',
    };
    AppRoutes.aromaticNote = {
        path: '/aromaticNote',
        key: 'aromaticNote',
    };
    return AppRoutes;
}());
export default AppRoutes;



//////////////////
// WEBPACK FOOTER
// ./src/config/appRoutes.ts
// module id = 2
// module chunks = 0